import Expenses from './Expenses';

export default Expenses;
